// @ts-ignore
export const loadingNav = (state) => state.navProcesses > 0;
export const loading = (state) => state.processes > 0;
